module.exports = __webpack_public_path__ + "img/university_7.04202861.jpg";